module.exports = "/images/delete.svg?29041449b02c8a249ea2f08aaacf3a70";